import { axiosInstance } from "../utils/axios";

export const inviteUser = async (data) => {
  return axiosInstance.post("/users/invite", data).then((res) => res.data);
};

export const inviteDriver = async (data) => {
  return axiosInstance.post("/drivers/invite", data);
};
